import { chatIcon, endCallIcon, flashIcon, flashOffIcon, micIcon, micOffIcon, muteIcon, volumeUpIcon } from '../../assets';
import './index.css';
import { useContext, useEffect, useState } from 'react';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';
import ChatStore from '../../stores/ChatStore';
import { observer } from 'mobx-react';
import SocketStore from '../../stores/SocketStore';
import { useNavigate } from 'react-router';
import strings from '../../localization';
import CallStore from '../../stores/CallStore';

const BottomBarButton = ({ icon, offIcon, text, action, isOn }) => {
  const [isOnState, setIsOn] = useState(isOn);
  return (
    <button className="customer-call-bottom-content-button button-round button-round-small" onClick={() => {
      setIsOn(!isOnState);
      action(!isOnState);
    }}>
      <img src={isOnState ? icon : offIcon} alt={text} style={{ filter: 'invert(1)' }} />
    </button>
  )
}

const TorchButton = ({ data }) => {

  const { icon, offIcon, text, action, isOn } = data;

  const isOnState = CallStore.isTorchOn;

  return (
    <button className="customer-call-bottom-content-button button-round button-round-small" onClick={() => {
      action(!isOnState);
    }}>
      <img src={isOnState ? icon : offIcon} alt={text} style={{ filter: 'invert(1)' }} />
    </button>
  )
}

const handleTorch = async (state, localVideoTrack) => {
  try {
    await localVideoTrack.getMediaStreamTrack().applyConstraints({
      advanced: [{ torch: state }]
    });
    SocketStore.sendCustomerTorch(state);
  } catch (error) {
    // console.log("🚀 ~ index.js:40 ~ CustomerCallBottom ~ error:", error);
  }
}


const CustomerCallBottom = ({ handleChatIsOpen, chatIsOpen, endCallViaAgora, localVideoTrack, setChatIsOpen }) => {

  const { showModalAlert, closeModalAlert } = useContext(ModalAlertContext);
  const navigate = useNavigate();


  useEffect(() => {
    handleTorch(CallStore.isTorchOn, localVideoTrack);
  }, [CallStore.isTorchOn]);

  const buttons = [
    {
      id: 1,
      icon: flashIcon,
      offIcon: flashOffIcon,
      isOn: CallStore.isTorchOn,
      text: 'FLASH',
      action: async (state) => {
        CallStore.setIsTorchOn(state);
      }
    },
    // {
    //   id: 2,
    //   icon: micIcon,
    //   offIcon: micOffIcon,
    //   isOn: true,
    //   key: 'isMuted',
    //   text: 'MIC',
    //   action: (state) => {
    //     const isMuted = localAudioTrack.muted;
    //     localAudioTrack.setMuted(!isMuted);
    //   }
    // },
    // {
    //   id: 3,
    //   icon: volumeUpIcon,
    //   offIcon: muteIcon,
    //   isOn: true,
    //   key: 'isVolumeOn',
    //   text: 'MUTE',
    //   action: (state) => {
    //     const volume = remoteAudioTrack._volume;
    //     var newVolume = volume === 0 ? 100 : 0;
    //     remoteAudioTrack.setVolume(newVolume)
    //   }
    // }
  ]

  const endCall = () => {
    setChatIsOpen(false);
    showModalAlert({
      title: strings.areYouSure,
      message: strings.areYouSureYouWantToEndTheCall,
      type: 'error',
      cancelText: strings.cancel,
      confirmText: strings.yesDoIt,
      position: 'vertical',
      onCancel: () => {
        closeModalAlert();
      },
      onConfirm: async () => {
        localStorage.removeItem('callToken');
        SocketStore.sendCustomerEndCall();
        closeModalAlert();
        await endCallViaAgora();
        navigate('/customer/review');
      }
    });
  }

  return (
    <div className="customer-call-bottom">
      <div className="customer-call-bottom-content">
        <button className="customer-call-bottom-content-button button-cta button-cta-small" onClick={() => {
          handleChatIsOpen();
        }}>
          <img src={chatIcon} alt="chat-icon" />
          <span>{strings.chat}</span>
          {ChatStore.unreadMessages > 0 && !chatIsOpen && <div className='customer-call-bottom-new-message-icon' ></div>}
        </button>
        <TorchButton data={buttons[0]} />
        {buttons.map(button =>
          button.id !== 1 && (
            <BottomBarButton key={button.id} isOn={button.isOn} icon={button.icon} offIcon={button.offIcon} text={button.text} action={button.action} />
          )
        )}
        <button
          onClick={endCall}
          className="customer-call-bottom-content-button button-round button-round-small customer-call-bottom-content-button-end-call">
          <img src={endCallIcon} alt="end-call-icon" />
        </button>
      </div>
    </div>
  );
};

export default observer(CustomerCallBottom);